"use client";
import { Icon } from "@/components/ui/icon";
import {
  PASSWORD_REQUIREMENTS,
  getPasswordStrength,
} from "../lib/password-policy";

interface PasswordStrengthProps {
  password: string;
  id?: string;
}

export function PasswordStrength({ password, id }: PasswordStrengthProps) {
  const { score, label, color, total } = getPasswordStrength(password || "");

  return (
    <div id={id} className="flex flex-col gap-2 pt-1">
      <div className="flex items-center gap-1.5">
        {label && (
          <span
            className="text-xs leading-4 font-normal shrink-0 whitespace-nowrap"
            style={{ color }}
          >
            {label}
          </span>
        )}
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className="flex-1 h-[5px] rounded-full min-w-0"
            style={{
              backgroundColor: i < score ? color : "var(--border-alpha)",
            }}
          />
        ))}
      </div>

      <div className="flex flex-wrap gap-2">
        {PASSWORD_REQUIREMENTS.map((req) => {
          const met = req.test(password || "");
          return (
            <div
              key={req.id}
              className={`flex items-center gap-1 border rounded-full px-1.5 py-0.5 transition-all ${
                met
                  ? "bg-contrast/10 border-contrast/20 text-heading"
                  : "bg-black/5 dark:bg-white/3 border-black/10 dark:border-white/8 text-contrast/40"
              }`}
            >
              <span className="text-xs leading-4 pl-0.5">{req.label}</span>
              {met ? (
                <Icon name="IconCheckmark1" size={14} />
              ) : (
                <Icon name="IconCrossSmall" size={14} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
